import { TextInput } from '../../baseInputs/TextInput';
import styled from 'styled-components';
import { useScene } from '../../../../context/sceneContext';

const isPatchkitDomain = (url?: string): boolean => {
  if (!url) return true; // Don't show warning for empty URLs
  try {
    const urlObj = new URL(url);
    const hostnameParts = urlObj.hostname.split('.');
    // Check if the last two parts are exactly "patchkit.net"
    return (
      hostnameParts.length >= 2 &&
      hostnameParts[hostnameParts.length - 2] === 'patchkit' &&
      hostnameParts[hostnameParts.length - 1] === 'net'
    );
  } catch {
    return false; // Invalid URL format
  }
};

export const SrcVariableInput = () => {
  const scene = useScene();

  const { type } = scene.getSelectedElementsData({ type: undefined }, '');
  const { src } = scene.getSelectedElementsData({ src: undefined }, 'props');

  const updateSrc = (value?: string) =>
    scene.updateSelectedElementsData(
      { src: value },
      'props',
      'srcVariableInput'
    );

  return (
    <Container>
      <Row>
        <TextInput
          label="URL"
          value={src}
          onChange={(newValue) => updateSrc(newValue)}
        />
      </Row>
      {type === 'img' && src && !isPatchkitDomain(src) && (
        <>
          <Warning>URL is not under patchkit.net domain!</Warning>
          <Info>
            The image may not be correctly cached and displayed in the offline
            mode of the launcher due to the CORS policy.
          </Info>
          <Info>Please upload the image to the editor's assets.</Info>
        </>
      )}
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
`;

const Row = styled.div`
  width: 100%;
  display: flex;
`;

const Warning = styled.div`
  text-align: center;
  color: #ff6b6b;
  font-size: 12px;
  margin-top: 4px;
`;

const Info = styled.div`
  color: #6b7280;
  font-size: 12px;
  margin-top: 4px;
`;
